import React from "react"

import { Button } from "buoy-core"
import Container from "../../common/components/Container"

import EmailInput from "./EmailInput"
import PasswordInput from "./PasswordInput"
import { HeadingTwo } from "buoy-core"
import { validatePassword } from "../../common/common"

const Form = ({
  showEmail,
  showPass,
  showPassConfirm,
  onKeyDown,
  onEmailChange,
  onPasswordChange,
  onConfirmChange,
  validateConfirm,
  authError,
  password,
  passwordConfirm,
  onSubmit,
  submitText,
  dashboard,
  disableSubmit,
  ...props
}) => (
  <React.Fragment>
    {showEmail && (
      <EmailInput
        {...props}
        showPass={showPass}
        onKeyDown={onKeyDown}
        authError={authError}
        onEmailChange={onEmailChange}
        maxWidth="none"
      />
    )}
    {showPass && (
      <PasswordInput
        {...props}
        password={password}
        onPasswordChange={onPasswordChange}
        onKeyDown={onKeyDown}
        showValid={showPassConfirm}
        errorMsg={
          (!showPassConfirm && authError && authError.msg) ||
          "Password must be at least 8 characters and contain at least 1 digit"
        }
        showPassedError={!showPassConfirm}
        error={authError && authError.status === "bad" && authError.msg}
      />
    )}
    {showPassConfirm && (
      <PasswordInput
        {...props}
        label="Confirm password"
        password={passwordConfirm}
        onPasswordChange={onConfirmChange}
        onKeyDown={onKeyDown}
        validate={validateConfirm}
        showValid={showPassConfirm}
        errorMsg={(authError && authError.msg) || "Passwords must match"}
        showPassedError
        error={authError && authError.status === "bad" && authError.msg}
      />
    )}
    <Button margin="0 0 4px" fullWidth={dashboard} onClick={onSubmit} disabled={disableSubmit}>
      {submitText}
    </Button>
  </React.Fragment>
)

class AuthForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      password: "",
      passwordConfirm: "",
    }
  }

  onPasswordChange = password => {
    this.setState({ password })
  }

  onConfirmChange = conf => {
    this.setState({ passwordConfirm: conf })
  }

  onSubmit = () => {
    this.props.onSubmit(this.state.password, this.state.passwordConfirm)
  }

  onKeyDown = e => {
    let key = e.keyCode || e.which
    if (key === 13) this.onSubmit()
  }

  validateConfirm = confirm => confirm === this.state.password

  disableSubmit = () => {
    let { password, passwordConfirm } = this.state
    let { disableSubmit, showPass, showPassConfirm } = this.props
    return disableSubmit || (showPass && !validatePassword(password)) ||
      (showPassConfirm && !this.validateConfirm(passwordConfirm))
  }

  render() {
    let {
      showEmail,
      showPass,
      showPassConfirm,
      submitText,
      onEmailChange,
      authError,
    } = this.props
    let { password, passwordConfirm } = this.state
    let disableSubmit = this.disableSubmit()
    return (
      <Form
        {...this.props}
        submitText={submitText}
        showEmail={showEmail}
        showPass={showPass}
        showPassConfirm={showPassConfirm}
        onKeyDown={this.onKeyDown}
        onSubmit={this.onSubmit}
        authError={authError}
        password={password}
        disableSubmit={disableSubmit}
        passwordConfirm={passwordConfirm}
        onEmailChange={onEmailChange}
        onConfirmChange={this.onConfirmChange}
        onPasswordChange={this.onPasswordChange}
        validateConfirm={this.validateConfirm}
      />
    )
  }
}

const AuthFormContainer = ({ children, ...props }) => (
  <Container marginRight="16px" marginLeft="16px" width="400px">
    <HeadingTwo color="primary">{props.title}</HeadingTwo>
    <AuthForm {...props} />
    {children}
  </Container>
)

export { AuthFormContainer as default, AuthForm }


// WEBPACK FOOTER //
// ./assets/auth/components/AuthForm.js